module.exports = __webpack_public_path__ + "static/media/Group9261.6f31b6f2.png";